(function() {
  window.bb_articles = window.bb_articles || {};

function renderComment(comment) {
  const name = comment.name && comment.name !== '' ? comment.name : 'Invité';
  const date = comment.createdAt
  ? new Date(comment.createdAt).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' })
  : '';
  const bodyContent = comment.content || '';
  const commentId = `comment-${comment.id}`;

  // Structure du commentaire principal
  let html = `
    <div id="${comment.id}" class="bb-comment-spacer"></div>
    <div class="bb-comment" >
      <div class="bb-comment__header">
        <strong class="bb-comment__author">${name}</strong>
        <span class="bb-comment__date">${date} (${comment.id})</span>
      </div>
      <div class="bb-comment__body" id="${commentId}" data-type="question" data-content="${encodeURIComponent(bodyContent)}"></div>
  `;

  // 💬 Gestion des réponses (Admin)
  if (Array.isArray(comment.replies) && comment.replies.length > 0) {
    const repliesHTML = comment.replies.map((reply, index) => {
      const replyName = reply.name && reply.name !== '' ? reply.name : 'Mathieu Nutrastream';
      const replyDate = reply.createdAt
        ? new Date(reply.createdAt).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' })
        : '';
      const replyContent = reply.content || '';
      const replyId = `reply-${comment.id}-${index}`;

      return `
        <div class="bb-comment bb-comment--reply" style="margin-left:25px;">
          <div class="bb-comment__header">
            <strong class="bb-comment__author">${replyName}</strong>
            <span class="bb-comment__date">${replyDate}</span>
          </div>
          <div class="bb-comment__body" id="${replyId}" data-type="reply" data-content="${encodeURIComponent(replyContent)}"></div>
        </div>
      `;
    }).join('');

    html += repliesHTML;
  }

  html += '</div>';
  return html;
}



  // ---- Initialisation des commentaires pour un article ----
  function initBBCommentsForArticle(articleId, articleData) {
    const container = document.getElementById(`bbcomments-container-${articleId}`);
    if (!container) return;

    const { comments = [] } = articleData;
    const bbWrapper = document.createElement("div");
    bbWrapper.className = "bbcomments-inner";
    container.appendChild(bbWrapper);

    // 🧠 Filtre uniquement les questions racine
    let roots = comments.filter(c => !c.isReply && !c.parentId);

    // 🔄 Trie les questions du plus récent au plus ancien
    roots = roots.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

    // 🚫 Limite à 8 questions max
    const limitedRoots = roots.slice(0, 8);


    let html = "";
    if (limitedRoots.length > 0) {
      html = limitedRoots.map(c => renderComment(c)).join('');
    } else {
      html = `<p class="bb-comment__empty">Aucun commentaire pour le moment.</p>`;
    }

    bbWrapper.innerHTML = html;
  }

  function initAllBBComments() {
    for (const [articleId, articleData] of Object.entries(window.bb_articles)) {
      initBBCommentsForArticle(articleId, articleData);
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    initAllBBComments();

    // ---- Gestion du compteur de caractères ----
    document.querySelectorAll('.bbcomment-form textarea[name="content"]').forEach(textarea => {
      const counter = textarea.parentElement.querySelector('.char-counter');
      textarea.addEventListener('input', () => {
        const length = textarea.value.length;
        counter.textContent = `${length} / 250`;
        counter.style.color = length >= 250 ? 'red' : '#888';
      });
    });

    // ---- Synchronisation automatique avec le formulaire Mailchimp caché ----
    const hiddenWrapper = document.querySelector('#hidden-mailchimp');

    function bindKlaviyoSync() {
      const hiddenForm = hiddenWrapper?.querySelector('form');
      if (!hiddenForm) return false;

      const mailInput =
        hiddenForm.querySelector('input[type="email"][name="email"]') ||
        hiddenForm.querySelector('input[type="email"]') ||
        hiddenForm.querySelector('input[name="email"]');

      const nameInput =
        hiddenForm.querySelector('input[id^="first_name_"]') ||
        hiddenForm.querySelector('input[autocomplete="given-name"]') ||
        hiddenForm.querySelector('input[placeholder="Prénom"]');

      if (!mailInput && !nameInput) return false;

      document.querySelectorAll('.bbcomment-form').forEach(form => {
        const nameField = form.querySelector('input[name="name"]');
        const emailField = form.querySelector('input[name="email"]');
        const newsletterField = form.querySelector('[name="newsletter"]');
        if (!newsletterField) return;

        const setKlaviyoValues = () => {
          if (nameInput && nameField) {
            nameInput.value = nameField.value;
            nameInput.dispatchEvent(new Event('input', { bubbles: true }));
            nameInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          if (mailInput && emailField) {
            mailInput.value = emailField.value;
            mailInput.dispatchEvent(new Event('input', { bubbles: true }));
            mailInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        };

        const clearKlaviyoValues = () => {
          if (nameInput) {
            nameInput.value = '';
            nameInput.dispatchEvent(new Event('input', { bubbles: true }));
            nameInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          if (mailInput) {
            mailInput.value = '';
            mailInput.dispatchEvent(new Event('input', { bubbles: true }));
            mailInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        };

        const syncIfChecked = () => {
          if (newsletterField.checked) setKlaviyoValues();
          else clearKlaviyoValues();
        };

        if (!form.dataset.klSyncBound) {
          if (nameField) {
            nameField.addEventListener('input', syncIfChecked);
            nameField.addEventListener('change', syncIfChecked);
          }
          if (emailField) {
            emailField.addEventListener('input', syncIfChecked);
            emailField.addEventListener('change', syncIfChecked);
          }
          newsletterField.addEventListener('change', syncIfChecked);
          form.dataset.klSyncBound = '1';
        }

        syncIfChecked();
      });

      return true;
    }

    if (hiddenWrapper) {
      if (!bindKlaviyoSync()) {
        const obs = new MutationObserver(() => {
          if (bindKlaviyoSync()) obs.disconnect();
        });
        obs.observe(hiddenWrapper, { childList: true, subtree: true });
      }
    }
    // ------ End synchronisation ------- //

  });

  // ---- Gestion du formulaire d’envoi ----
  document.addEventListener('submit', async e => {
    const form = e.target.closest('.bbcomment-form');
    if (!form) return;
    e.preventDefault();

    const articleId = form.dataset.articleId;
    const articleData = window.bb_articles[articleId];
    const msg = form.querySelector('.bbcomment-form__message');
    msg.style.display = 'none';

    const name = form.name.value.trim();
    const email = form.email.value.trim();
    const content = form.content.value.trim();
    const privacyChecked = form.querySelector('[name="privacy"]').checked;
    const newsletterChecked = form.querySelector('[name="newsletter"]').checked;

    // RGPD
    if (!privacyChecked) {
      msg.textContent = 'Merci d’accepter la politique de confidentialité avant d’envoyer votre question.';
      msg.style.display = 'block';
      msg.style.color = 'red';
      return;
    }

    if (!name || !email || !content) {
      msg.textContent = 'Merci de remplir tous les champs.';
      msg.style.display = 'block';
      msg.style.color = 'red';
      return;
    }

    // ✅ Soumission du formulaire Klaviyo caché uniquement si la case NL est cochée
    if (newsletterChecked) {
      const klaviyoForm = document.querySelector('#hidden-mailchimp form');

      // IMPORTANT: sur Klaviyo embed, le vrai trigger est souvent un button[type="button"]
      const klaviyoBtn =
        klaviyoForm?.querySelector('button[type="button"]') ||
        klaviyoForm?.querySelector('input[type="submit"]');

      if (klaviyoForm && klaviyoBtn) {
        console.log('Klaviyo : soumission silencieuse...');
        klaviyoBtn.click();
      }
    }

    // ---- Envoi du commentaire
    const data = {
      articleId,
      articleHandle: articleData.article_handle,
      blogId: articleData.blog_id,
      blogHandle: articleData.blog_handle,
      name,
      email,
      content
    };

    const APP_URL = articleData.app_url || '/apps/comments/customer/comments/create';

    try {
      const res = await fetch(APP_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });

      const result = await res.json();

      if (res.ok) {
        msg.textContent = 'Merci ! Votre question a été envoyée et sera publiée après validation.';
        msg.style.display = 'block';
        msg.style.color = 'green';
        form.reset();
        const counter = form.querySelector('.char-counter');
        if (counter) counter.textContent = '0 / 250';
      } else {
        msg.textContent = result.error || 'Une erreur est survenue.';
        msg.style.display = 'block';
        msg.style.color = 'red';
      }
    } catch (err) {
      console.error('Erreur d’envoi du commentaire :', err);
      msg.textContent = 'Une erreur de connexion est survenue.';
      msg.style.display = 'block';
      msg.style.color = 'red';
    }
  });

  window.bbInitAllComments = initAllBBComments;
  // ---- Déclenche les animations "..." à la visibilité ----
function initTypingObserver() {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        observer.unobserve(el); // évite de relancer

        const type = el.dataset.type;
        const content = decodeURIComponent(el.dataset.content || '');
        const typingEl = document.createElement('div');
        typingEl.className = 'typing-indicator';
        typingEl.innerHTML = '<span></span><span></span><span></span>';
        el.appendChild(typingEl);

        // Durée différente selon le type
        const duration = type === 'reply' ? 2950 : 1750;

        setTimeout(() => {
          typingEl.remove();
          el.innerHTML = content;
        }, duration);
      }
    });
  }, {
    threshold: 0.2 // déclenche à 20% de visibilité
  });

  // On attache l’observer à tous les commentaires existants
  document.querySelectorAll('.bb-comment__body').forEach(el => observer.observe(el));
}

document.addEventListener("DOMContentLoaded", () => {
  // ... ton initAllBBComments(), etc
  setTimeout(initTypingObserver, 500); // petit délai pour s'assurer que le DOM est prêt
});

})();
